import { createDraftContext } from '../../../context'

export const ApplicantDraft = createDraftContext()
